const en = require('./en.json');
const es = require('./es.json');
const pt = require('./pt.json');

export default {
  en,
  es,
  pt,
};
